import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from "primeng/components/common/messageservice";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
import {ActivatedRoute, Router} from '@angular/router';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

@Component({
  selector: 'addSubjectsS',
  templateUrl: 'view-paper.component.html',
  styleUrls: ['view-paper.component.scss'],

})
export class ViewPaperComponent implements OnInit {



  public schoolId: any;

  public userId :string;
  public BranchId :string;

  public paper :string;

  public PDFfile: any;
  public searchHistory: any;

  public pdfUrl: SafeResourceUrl;



  loading = "none";


  constructor(private dataAnalyticsService: DataAnalyticsService,
              private messageService: MessageService,
              private noticeboardService: NoticeboardService,
              private confirmationService: ConfirmationService,
              private localStorage: LocalStorageService,
              private route: ActivatedRoute,
              private router: Router,
              private sanitizer: DomSanitizer,

  ) {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    this.userId = this.localStorage.retrieve('id');
    this.BranchId = this.localStorage.retrieve('branchid');

  }

  ngOnInit() {
    const objString = this.route.snapshot.queryParamMap.get('paper');
    const historyString = this.route.snapshot.queryParamMap.get('history');

    this.paper = JSON.parse(decodeURIComponent(objString));
    this.searchHistory = JSON.parse(decodeURIComponent(historyString));

    console.log(this.searchHistory.yearId);
    console.log(this.searchHistory.selectedLevel);
    console.log(this.searchHistory.selectedGrade);
    console.log(this.searchHistory.selectedSubject);
    console.log(this.searchHistory.selectedSemester);
    console.log(this.searchHistory.selectedTest);
    console.log(this.searchHistory.selectedPaperType);

    if (typeof this.paper === 'string') {
      this.paper = JSON.parse(this.paper); // Parses it again if it’s still a string
    }

    console.log(this.paper);

    this.PDFfile = this.paper['PDFContent'];

    this.displayPdf(this.PDFfile);
  }


  displayPdf(base64String: string) {
    // console.log('base64String');
    const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64,${base64String}`);
    this.pdfUrl = safeUrl;
    console.log(this.pdfUrl);
  }

  goBack() {
    const serializedHistory = encodeURIComponent(JSON.stringify(this.searchHistory));

    this.router.navigate(['parent/question-bank'], {
      queryParams:{
        history: serializedHistory
      }
    });
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/view-paper/view-paper.component.ts